module.exports = __webpack_public_path__ + "img/gps.9da10a8a.svg";